module.exports = __webpack_public_path__ + "play.png?1f14e2ace7b3b99af2cc6d7993503942";


//////////////////
// WEBPACK FOOTER
// ./lib/assets/play.png
// module id = 15
// module chunks = 0